import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × AMI PARIS: Heart meets algorithm
// Red hearts, hand-drawn lines, pastel grids
export function VasarelyAmiMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="ami-warm" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFE5E5" />
          <stop offset="50%" stopColor="#FFD0D0" />
          <stop offset="100%" stopColor="#FFC0C0" />
        </linearGradient>
      </defs>

      {/* Warm pastel background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#ami-warm)" />

      <g transform="translate(397 540)">
        {/* Pastel grid */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 60;
            const y = (j - 7.5) * 60;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 28}
                y={y - 28}
                width="56"
                height="56"
                fill="none"
                stroke="#FFB0B0"
                strokeWidth="1"
                opacity="0.3"
              />
            );
          })
        )}

        {/* Hand-drawn lines (organic feel) */}
        {Array.from({ length: 20 }).map((_, i) => {
          const y = -400 + i * 40;
          const wave = Math.sin(i * 0.5) * 10;
          
          return (
            <path
              key={i}
              d={`M ${-350 + wave} ${y} Q ${wave} ${y} ${350 + wave} ${y}`}
              fill="none"
              stroke="#FF6B6B"
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Heart tessellation */}
        {Array.from({ length: 8 }).map((_, i) =>
          Array.from({ length: 10 }).map((_, j) => {
            const x = (i - 3.5) * 80;
            const y = (j - 4.5) * 90;
            
            return (
              <g key={`${i}-${j}`} transform={`translate(${x} ${y})`}>
                {/* AMI heart shape */}
                <path
                  d="M 0,-10 C -15,-25 -30,-15 -30,0 C -30,15 0,30 0,30 C 0,30 30,15 30,0 C 30,-15 15,-25 0,-10 Z"
                  fill="#E63946"
                  opacity="0.15"
                  strokeWidth="1"
                  stroke="#E63946"
                />
              </g>
            );
          })
        )}

        {/* Emotional precision circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 50 + i * 30;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#E63946"
              strokeWidth="2"
              opacity={0.3 - i * 0.025}
            />
          );
        })}

        {/* Central heart */}
        <path
          d="M 0,-30 C -45,-75 -90,-45 -90,0 C -90,45 0,90 0,90 C 0,90 90,45 90,0 C 90,-45 45,-75 0,-30 Z"
          fill="#E63946"
          opacity="0.8"
        />
        <path
          d="M 0,-20 C -30,-50 -60,-30 -60,0 C -60,30 0,60 0,60 C 0,60 60,30 60,0 C 60,-30 30,-50 0,-20 Z"
          fill="#FFFFFF"
          opacity="0.3"
        />

        {/* Algorithmic heart grid */}
        <rect x="-90" y="-90" width="180" height="180" fill="none" stroke="#E63946" strokeWidth="1" opacity="0.4" />
        <rect x="-80" y="-80" width="160" height="160" fill="none" stroke="#E63946" strokeWidth="1" opacity="0.3" />
      </g>

      {/* Emotional precision */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#E63946" fontWeight="400">
        cœur algorithmique
      </text>
    </g>
  );
}
